<template>
  <div class="layout profiles">
    <remove-item-modal ref="removeItemModal" @remove="onItemRemoved"></remove-item-modal>

    <div class="layout-header">
      <h2 class="layout-title">Анкеты</h2>
      <div class="layout-header-actions">
        <div class="layout-header-action">
          <c-button
            :responsive="true"
            size="small"
            :icon="{ icon: 'plus', color: 'primary' }"
            label="Новая анкета"
            @click="$router.push({ name: 'create-profile' })"
          />
        </div>
      </div>
    </div>

    <div class="layout-content">
      <c-loader v-if="!inited" class="loader" :active="loading" label="Данные загружаются" :height="450" />

      <div v-else-if="isEmpty" class="empty-message">Анкет пока нет</div>

      <template v-else>
        <filters :filters="filters" @apply="applyFilters" />

        <div v-if="!loading && totalCount === 0" class="empty-message">
          Ничего не найдено. Попробуйте изменить параметры поиска.
        </div>

        <list :list="list" :loading="loading" @nextPage="nextPage" @removeItem="removeItem" />
      </template>
    </div>

    <top-button root=".layout"></top-button>

    <transition name="fade"><show-items v-if="!loading" :count="list.length" :total="totalCount" /></transition>
  </div>
</template>

<script>
import CButton from "@/components/controls2/Button";
import CLoader from "@/components/loader";
import TopButton from "@/components/top-button";
import ShowItems from "@/components/show-items";

import Filters from "./components/Filters";
import List from "./components/List";
import RemoveItemModal from "./components/RemoveItemModal";

import { Profile } from "./models/Profile";

export default {
  components: { CButton, ShowItems, CLoader, TopButton, RemoveItemModal, Filters, List },
  data() {
    return {
      inited: false,
      isEmpty: false,
      loading: false,
      filters: {
        positions: [],
        positionsExclude: false,
        name: "",
      },
      page: 1,
      hasMoreItems: true,
      positions: [],
      list: [],
      totalCount: 0,
    };
  },
  async created() {
    this.$store.dispatch("positions/getPositionsList");

    this.getProfiles(this.getParams()).then((response) => {
      this.isEmpty = response.totalCount === 0;
      this.inited = true;
      this.initFilters();
      this.loadProfiles();
    });
  },
  methods: {
    initFilters() {
      const { query } = this.$route;

      if (query.positions) {
        this.filters.positions = query.positions.split(",").map((p) => ({ value: p }));
        this.filters.positionsExclude = query.positionsExclude === "1";
      }

      if (query.name) {
        this.filters.name = query.name;
      }
    },
    fixFilters() {
      const { positions, positionsExclude, name } = this.filters;
      const { query } = this.$route;
      const newQuery = {
        ...query,
        positions: positions.map((p) => p.value).join(","),
        positionsExclude: positionsExclude ? "1" : "0",
        name,
      };

      if (JSON.stringify(query) === JSON.stringify(newQuery)) return;
      this.$router.push({ query: newQuery });
    },
    getProfiles(params) {
      return this.$store.dispatch("profile/getProfiles", params);
    },
    async loadProfiles() {
      this.loading = true;
      this.fixFilters();

      const response = await this.getProfiles(this.getParams());

      const { items, currentPage, pageCount, totalCount } = response;
      this.hasMoreItems = currentPage < pageCount;
      this.totalCount = totalCount;
      this.list = [...this.list, ...items.map((item) => Profile(item))];

      this.loading = false;
    },
    getParams() {
      const { positions, positionsExclude, name } = this.filters;

      return {
        posts: positions.map((p) => p.value),
        posts_exclude: positionsExclude ? 1 : 0,
        search: name,
        page: this.page,
      };
    },
    resetPagination() {
      this.page = 1;
      this.hasMoreItems = true;
      this.list = [];
    },
    applyFilters() {
      this.resetPagination();
      this.loadProfiles();
    },

    nextPage() {
      if (this.loading) return;
      if (!this.hasMoreItems) return;
      this.page += 1;
      this.loadProfiles();
    },
    removeItem(item) {
      this.$refs.removeItemModal.open(item);
    },
    onItemRemoved() {
      this.applyFilters();
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/vars";

.profiles {
  .layout-header {
    height: auto;
    min-height: 30px;
  }

  .layout-content {
    padding-bottom: 40px;
  }

  .empty-message {
    color: $label;
    font-size: 15px;
  }

  @include bootstrapMd {
    .layout-content {
      padding-bottom: 80px;
    }
  }

  @include bootstrapLg {
    .layout-content {
      padding-bottom: 30px;
    }
  }
}
</style>
